<template>
  <input class="row-nice__input" type="week" v-model="value_local" @keyup="updateValue" @change="updateValue"/>
</template>

<script>
import InputBase from "./InputBase";

export default {
  name: "InputWeek",
  extends: InputBase,
  props: {
    name: {},
    value: {}
  },
  data() {
    return {
      value_local: null,
    }
  },
  methods: {
    val() {
      return this.value_local;
    },
    updateValue() {
      this.$emit('updateValue', this.name, this.value_local);
    }
  },

  mounted() {
    this.value_local = this.value;
  },
  watch: {

    value(newValue, oldValue) {

      this.value_local = newValue;

    },
  },
}
</script>